"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortExpiryStringsPredicate = exports.sortCurrenciesPredicate = exports.sortingInstrumentsPredicate = void 0;
const volatilitySmile_1 = require("../calculationsCore/volatilitySmile");
const index_1 = require("../index");
const sortingInstrumentsPredicate = (instrumentA, instrumentB) => {
    const positionTypeA = (0, index_1.getInstrumentType)(instrumentA);
    const positionTypeB = (0, index_1.getInstrumentType)(instrumentB);
    const typeA = positionTypeA === index_1.PositionType.Option ? 1 : -1;
    const typeB = positionTypeB === index_1.PositionType.Option ? 1 : -1;
    const isLinearA = positionTypeA === index_1.PositionType.LinearPerpetual ? -1 : 1;
    const isLinearB = positionTypeB === index_1.PositionType.LinearPerpetual ? -1 : 1;
    const directionPosA = positionTypeB === index_1.PositionType.Option
        ? (0, volatilitySmile_1.getOptionInstrumentParts)(instrumentA).direction
        : 0;
    const strikePosA = positionTypeA === index_1.PositionType.Option
        ? (0, volatilitySmile_1.getOptionInstrumentParts)(instrumentA).strike
        : 0;
    const strikePosB = positionTypeA === index_1.PositionType.Option
        ? (0, volatilitySmile_1.getOptionInstrumentParts)(instrumentB).strike
        : 0;
    const expirationA = instrumentA.includes("PERP")
        ? 0
        : (0, index_1.getExpiryTimestampFromInstrumentString)(instrumentA);
    const expirationB = instrumentB.includes("PERP")
        ? 0
        : (0, index_1.getExpiryTimestampFromInstrumentString)(instrumentB);
    const currencyA = (0, index_1.getBaseCurrencyFromInstrumentString)(instrumentA);
    const currencyB = (0, index_1.getBaseCurrencyFromInstrumentString)(instrumentB);
    return (currencyA.localeCompare(currencyB) ||
        isLinearA - isLinearB ||
        typeA - typeB ||
        expirationA - expirationB ||
        strikePosA - strikePosB ||
        (directionPosA === index_1.OptionType.CALL ? -1 : 1));
};
exports.sortingInstrumentsPredicate = sortingInstrumentsPredicate;
const sortCurrenciesPredicate = (currencyA, currencyB) => {
    return currencyA.localeCompare(currencyB);
};
exports.sortCurrenciesPredicate = sortCurrenciesPredicate;
const sortExpiryStringsPredicate = (expiryA, expiryB) => {
    return (0, exports.sortingInstrumentsPredicate)(`BTC-${expiryA}`, `BTC-${expiryB}`);
};
exports.sortExpiryStringsPredicate = sortExpiryStringsPredicate;
